export default {
    en: {
        required: 'Field is required'
    },
    et: {
        required: 'Väli on kohustuslik'
    }
}